import type { FC, ReactNode } from 'react';

import Text from '@/components/Text';

type Props = {
  children: ReactNode;
  title: string;
  subtitle: string;
};
const FilterSection: FC<Props> = ({ children, subtitle, title }) => {
  return (
    <div className="flex flex-col gap-1 lg:flex-row lg:gap-0">
      <div className="shrink-0 lg:w-40">
        <Text variant="jb-body-medium">{title}</Text>
        <Text variant="jb-body-small" className="text-jb-neutral-700">
          {subtitle}
        </Text>
      </div>
      {children}
    </div>
  );
};

export default FilterSection;
